import React from "react";

import TagList from "components/TagList";
import { TableLink } from "components/BaseTableV3/TableLink";
import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import { EPOCH_TIMESTAMP } from "constants/Constants";
import { capitalize, formatDate, tableTimestamp } from "components/helpers";

const LastEventCell = ({ action, date }) => {
  if (!action || !date) {
    return <p>No events</p>;
  }

  return (
    <p>
      {capitalize(action)} in {formatDate(date)}
    </p>
  );
};

export const getDialSessionsContactTableColumns = ({ invalidateData }) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <TableLink href={`/contacts/${row.original.contact.id}`}>
          {row.original.contact.id}
        </TableLink>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "contact.full_name",
      cell: ({ row }) => (
        <TableLink href={`/contacts/${row.original.contact.id}`}>
          {row.original.contact.full_name}
        </TableLink>
      ),
    },
    {
      header: "Contact Alternate Name",
      id: "Contact Alternate Name",
      accessorKey: "contact.alternate_names",
      enableSorting: false,
      cell: ({ row }) => (
        <ScrollColumn>
          {row.original.contact.alternate_names.map(({ id, name }) => (
            <li key={id}>{name}</li>
          ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Entity",
      id: "Entity",
      accessorKey: "entity.name",
      cell: ({ row }) => (
        <TableLink href={`/entities/${row.original.entity.id}`}>
          {row.original.entity.name}
        </TableLink>
      ),
    },
    {
      header: "Email",
      id: "Email",
      accessorKey: "contact.email",
    },
    {
      header: "Alternate Emails",
      id: "Alternate Emails",
      accessorKey: "contact.email_addresses",
      enableSorting: false,
      cell: ({ row }) => (
        <ScrollColumn>
          {row.original.contact.email_addresses
            .filter(email => !email.is_primary)
            .map(email => (
              <li key={email.id}>{email.email}</li>
            ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Title",
      id: "Title",
      accessorKey: "contact.title",
    },
    {
      header: "Phone Numbers",
      id: "Phone Numbers",
      enableSorting: false,
      cell: ({ row }) => (
        <ScrollColumn>
          {row.original.contact.phone_numbers.map(phone => (
            <li key={phone.id}>
              {phone.ext ? `${phone.number}x${phone.ext}` : phone.number}
            </li>
          ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Timezone",
      id: "Timezone",
      accessorKey: "timezone",
    },
    {
      header: "Last Called At",
      id: "Last Called At",
      accessorKey: "last_called_at",
      cell: ({ row }) => {
        if (row.original.last_called_at === EPOCH_TIMESTAMP) {
          return null;
        }
        return tableTimestamp(row.original.last_called_at);
      },
    },
    {
      header: "Last Disposition",
      id: "Last Disposition",
      accessorKey: "last_call_disposition",
    },
    {
      header: "Callback Time",
      id: "Callback Time",
      accessorKey: "callback_time",
      cell: ({ row }) => formatDate(row.original.callback_time),
    },
    {
      header: "Contact Tags",
      id: "Contact Tags",
      accessorKey: "contact.tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.original.contact.tags}
          modelType="Contact"
          modelId={row.original.id}
          onUpdate={invalidateData}
          tableCell
        />
      ),
    },
    {
      header: "Entity Tags",
      id: "Entity Tags",
      accessorKey: "entity.tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.original.entity.tags}
          modelType="Entity"
          modelId={row.original.entity.id}
          onUpdate={invalidateData}
          tableCell
        />
      ),
    },
    {
      header: "Last Email Event",
      id: "Last Email Event",
      enableSorting: false,
      cell: ({ row }) => (
        <LastEventCell
          action={row.original.last_email_action}
          date={row.original.last_email_date}
        />
      ),
    },
    {
      header: "Last Form Event",
      id: "Last Form Event",
      enableSorting: false,
      cell: ({ row }) => (
        <LastEventCell
          action={row.original.last_form_action}
          date={row.original.last_form_date}
        />
      ),
    },
  ];
};
